export default __webpack_public_path__ + "static/media/paus.d4007169.svg";